<template>
  <div class="shop-container">
    <div class="title-store">
      <i :class="`icon-${type}`"></i>
      <div class="label-box">
        <div class="bg"></div>
        <span class="label-shadow">{{ title }}</span>
        <span class="label-text">{{ title }}</span>
      </div>
    </div>
    <ul v-if="goodsList">
      <li v-for="(goods) in goodsList" :key="goods.goodsId" @click="exchange(goods, type)">
        <div class="goods-container" :class="isMall ? 'pricebg' : 'residentbg'">
          <div class="desc">
            <div class="label-box">
              <span class="label-shadow">{{ goods.desc }}</span>
              <span class="label-text">{{ goods.desc }}</span>
            </div>
          </div>
          <div class="pesticide">剩余{{ isMall ? goods.dailyLimit - goods.dailyReward : goods.totalLimit -
            goods.totalReward }}</div>
          <div class="quan"></div>
          <div class="icon" :style="{ 'background-image': `url(${goods.imgUrl})` }">
            <div class="num">
              x{{ goods.num }}
            </div>
          </div>
          <div class="price" v-if="isMall">
            <div v-if="goods.dailyLimit > goods.dailyReward" class="centering">
              <i></i>{{ goods.cost }}
              <TipDot v-show="goods.cost == 1" placement="price"></TipDot>
            </div>
          </div>
          <div class="price resident" v-else>
            <div v-if="goods.totalLimit >= goods.totalReward" class="centering">
              <i></i>{{ goods.cost }}
            </div>
          </div>
        </div>
        <div v-if="isMall" v-show="goods.dailyReward >= goods.dailyLimit" class="mask">
          <div class="sellout">售罄</div>
        </div>
        <div v-else v-show="goods.totalReward >= goods.totalLimit" class="mask">
          <div class="sellout">售罄</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as api from "@/service/index";
import TipDot from '@/components/tip-dot.vue';

export default {
  name: 'DailyShop',
  components: {
    TipDot
  },
  data() {
    return {
      countdown: '加载中...',
    }
  },
  props: {
    goodsList: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(['amount', 'token', 'isInterdict']),
    isMall() {
      return this.type === 'mall';
    }
  },
  watch: {
    'countdown': {
      handler() {
        // this.formatCountdown()
      },
      immediate: true
    }
  },
  methods: {
    exchange(goods, type) {
      this.$emit('exchange', goods, type);
    },
    async formatCountdown() {
      try {
        const now = await api.reqcurrentTime()
        if (now.status == 200) {
          const targetTime = this.amount.part2StartTime * 1000;
          // console.log('targetTime',targetTime);

          const currentTime = new Date(now.data).getTime();
          // console.log('currentTime',currentTime);
          const timeDifference = targetTime - currentTime;
          // console.log('timeDifference',timeDifference);
          if (timeDifference <= 0) {
            this.countdown = 0
            return
          }
          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // 计算剩余天数
          const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // 计算剩余小时


          this.countdown = `${days}日${hours}时`;
          // console.log('countdown',this.countdown)
        }
      } catch (err) {
        console.log(err)
      }
    },
  }
};

</script>

<style lang="scss" scoped>
@mixin textShadow($size, $color) {
  text-shadow: 0px -#{$size} $color,
  -#{$size} 0px $color,
  #{$size} 0px $color,
  0px #{$size} $color,
  #{$size} -#{$size} $color,
  -#{$size} -#{$size} $color,
  -#{$size} #{$size} $color,
  #{$size} #{$size} $color;
}


.shop-container {
  margin-bottom: get_vw(18px);

  .title-store {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: fit-content;
    font-size: get_vw(24px);
    margin-bottom: get_vw(14px);

    .bg {
      position: absolute;
      bottom: -20%;
      width: 100%;
      height: get_vw(19px);
      background-image: url('https://website.xdcdn.net/poster/58881/20250717/K72twEiz.png');
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }

    i {
      position: relative;
      width: get_vw(36px);
      height: get_vw(36px);
      margin-right: get_vw(8px);

      &.icon-mall {
        @include icon_status('store_daily_1', $hook: 'vw');
      }
      &.icon-resident {
        @include icon_status('store_resident_1', $hook: 'vw');
      }
    }
  }


  ul {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    li {
      position: relative;
      height: get_vw(100px);
      margin-bottom: get_vw(16px);
      flex-basis: calc(25% - get_vw(12px));
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      @include boxShadowSet_Btn();

      .goods-container {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/K91fgmAN.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: get_vw(10px);
        border: get_vw(4px) solid #FFFFFF;
        overflow: hidden;

        &.pricebg {
          background-image: $bg_store_daily;
        }

        &.residentbg {
          background-image: $bg_store_resident;
        }
      }

      .mask {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
        border-radius: get_vw(10px);
        overflow: hidden;
        display: flex;
        align-items: center;
        .sellout {
          position: relative;
          width: 100%;
          height: get_vw(40px);
          background-color: rgba(0, 0, 0, 0.3);
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          @include fontSet($size: 20px);
        }
      }

      .desc {
        position: absolute;
        top: get_vw(9px);
        right: get_vw(12px);
        // @include fontSet($size: 20px);
        font-size: get_vw(20px);
        text-align: left;

        .label-box {
          .label-shadow {
            color: #fff;
          }

          .label-text {
            color: #333;
          }
        }
      }

      .pesticide {
        position: absolute;
        top: get_vw(46px);
        right: get_vw(12px);
        height: get_vw(12px);
        border-radius: get_vw(10px);
        background-color: rgba(255, 255, 255, 0.5);
        font-size: get_vw(16px);
        padding: get_vw(5px) get_vw(9px);
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #666;
      }

      .quan {
        position: absolute;
        top: get_vw(14px);
        left: get_vw(16px);
        width: get_vw(74px);
        height: get_vw(74px);
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/K9EkKlDF.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      }

      .icon {
        position: absolute;
        top: get_vw(21px);
        left: get_vw(6.47px);
        width: get_vw(93.77px);
        height: get_vw(61.72px);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      }

      .num {
        font-size: get_vw(16px);
        text-align: right;
        position: absolute;
        top: get_vw(44.6px);
        right: get_vw(14.77px);
        color: #fff;
        font-weight: bold;
        @include textShadow(1px, black);

      }

      .price {
        width: get_vw(152px);
        height: get_vw(32px);
        position: absolute;
        right: get_vw(2px);
        bottom: get_vw(2px);
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/K91Y8XMc.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        color: #333;
        border-radius: 0 0 get_vw(10px) 0;
        font-size: get_vw(16px);

        .centering {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: get_vw(12px);
        }

        i {
          position: relative;
          top: get_vw(-1px);
          display: inline-block;
          @include sprite_bg('quiz_coin');
          width: get_vw(19.26px);
          height: get_vw(20.22px);
          margin-right: get_vw(3.74px)
        }
      }
    }

    li:nth-child(4n+1),
    li:nth-child(4n+2),
    li:nth-child(4n+3) {
      margin-right: get_vw(16px);
    }
  }
}
</style>